module.exports = __webpack_public_path__ + "img/_location_pin.b2031252.svg";